export default function TextField({ label, error, helperText, name, value, onChange, onBlur, type = "text" }) {
  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <input
        id={name}
        name={name}
        type={type}
        className="form-control form-control-rounded"
        value={value}
        onChange={onChange}  // Formik expects event object
        onBlur={onBlur}      // Formik expects event
      />
      {error && <div className="text-danger mt-1 ms-2">{helperText}</div>}
    </div>
  );
}
